export default __webpack_public_path__ + "static/media/Group 729.b770ff1c.svg";